<template>
  <div class="h-100">
    <div class="display-center">
      <WeChatBindMobilePhoneModal v-show="authFlag === AUTH_FLAG.UNBIND" ref="wechatBindMobilePhoneModal"
                                  @success="doLogin"/>
      <template v-if="authFlag === AUTH_FLAG.SUCCESS">
        <div class="progress-9"></div>
        <div class="m-3 self-font">授权登录中，请稍等...</div>
      </template>
      <div v-show="authFlag === AUTH_FLAG.FAIL" class="m-3 self-font">加载中,请稍等...</div>
      <a-result v-if="authFlag === AUTH_FLAG.OTHER_ERROR"
                status="error"
                :title="otherErrorMsg"></a-result>
    </div>
  </div>
</template>

<script>
import WeChatBindMobilePhoneModal from './WeChatBindMobilePhoneModal.vue'
import { WeChatLogin, WeChatCallback } from '@/views/login/api/LoginApi'
import { getSysTitle } from '@/utils/auth'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { AUTH_FLAG } from '@/views/login/util/WeChatUtil'

export default {
  name: 'WeChartAuth',
  computed: {},
  components: { WeChatBindMobilePhoneModal },
  data () {
    return {
      AUTH_FLAG,
      code: '',
      bindingVisible: false,
      //认证状态 200 成功绑定 203 未绑定 204 绑定失败/重新授权
      authFlag: AUTH_FLAG.FAIL,
      otherErrorMsg: '登录失败，请联系管理员',
    }
  },
  created () {
    const params = this.$helper.getQueryParams()
    this.init(params)
  },
  methods: {
    async init (data) {
      await getSysTitle()
      if (data.code) {
        this.code = data.code
        await this.doWeChatCallback()
      } else {
        if (this.$ls.get(ACCESS_TOKEN)) {
          this.$router.replace({ path: '/expertWeixMappage' })
        } else {
          WeChatLogin().then((res) => {
            if (res.code === 200) {
              window.location.href = res.msg
            }
          })
        }
      }
    },
    async doWeChatCallback () {
      const that = this
      const res = await WeChatCallback({ code: this.code })
      that.authFlag = res.code
      if (res.code === 200) {
        this.$store
            .dispatch('ExpertLoginByWeChat', res)
            .then(() => {
              that.$router.replace({ path: '/expertWeixMappage' })
            })
            .catch((error) => {
              that.authFlag = AUTH_FLAG.FAIL
            })
        this.$message.success('授权成功')
      } else if (res.code === AUTH_FLAG.UNBIND) {
        that.$refs.wechatBindMobilePhoneModal.init(res.result)
      } else if (res.code === AUTH_FLAG.FAIL) {
        WeChatLogin().then((res) => {
          if (res.code === 200) {
            window.location.href = res.msg
          }
        })
      } else {
        that.otherErrorMsg = res.msg
      }
    },
    doLogin (data) {
      const that = this
      this.$store
          .dispatch('ExpertLogin', data)
          .then(() => {
            that.$router.replace({ path: '/expertWeixMappage' })
          })
          .catch((error) => {
            that.authFlag = AUTH_FLAG.FAIL
          })
    },
  },
}
</script>

<style lang="less" scoped>
.h-100 {
  height: 100%;
}

.display-center {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .self-font {
    font-weight: bold;
    font-size: 18px;
  }
}

.progress-9 {
  --r1: 154%;
  --r2: 68.5%;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: radial-gradient(var(--r1) var(--r2) at top,
  #0000 79.5%,
  #269af2 80%) center left,
  radial-gradient(var(--r1) var(--r2) at bottom, #269af2 79.5%, #0000 80%) center center,
  radial-gradient(var(--r1) var(--r2) at top, #0000 79.5%, #269af2 80%) center right,
  #ccc;
  background-size: 50.5% 220%;
  background-position: -100% 0%, 0% 0%, 100% 0%;
  background-repeat: no-repeat;
  animation: p9 2s infinite linear;
}

@keyframes p9 {
  33% {
    background-position: 0% 33%, 100% 33%, 200% 33%;
  }
  66% {
    background-position: -100% 66%, 0% 66%, 100% 66%;
  }
  100% {
    background-position: 0% 100%, 100% 100%, 200% 100%;
  }
}
</style>
